import { Default, Detail,  List, Create } from "./views";

const Module = {
    name: "pianoconticfgroups",
    defaultRoutePath: "/cashflows/pianoconticfgroup",
    menuItemScope: "legalentities",
    menuItemName: "pianoconticfgroups",
    routes: [
        {
            path: "/cashflows/pianoconticfgroup",
            protected: true,
            children: [
                {
                    index: true,
                    path: "",
                    Component: Default,
                },
                {
                    path: "list",
                    Component: List,
                },
            ],
        },
    ],
    drawerRoutes: [
        {
            path: "list",
            Component: List,
        },
        {
            path: "detail",
            Component: Detail,
        },
        
        {
            path: "create",
            Component: Create,
        },
    ],

}

export default Module;
